// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_logo_title-module__logoTitle--TsThk{display:inline-block;padding-left:10px;font-size:21px;color:#323232;font-family:'Lato', sans-serif;padding-bottom:1px}\n", ""]);
// Exports
exports.locals = {
	"logoTitle": "header_logo_title-module__logoTitle--TsThk"
};
module.exports = exports;
